module.exports = __webpack_public_path__ + "static/media/IMG_20180315_192832.b6398778.webp";